import { z } from 'zod';

const DEFAULT_MESSAGE = 'Obrigatório'

export const formSchema = z
  .object({
    name: z.string({ message: DEFAULT_MESSAGE }).min(1, { message: DEFAULT_MESSAGE }),
    carrier_id: z.string({ message: DEFAULT_MESSAGE }),
    general_company_id: z.string({ message: DEFAULT_MESSAGE }),
    is_export: z.string({ message: DEFAULT_MESSAGE }),
    general_harbor_id: z.string().optional(),
    backward_trip: z.string({ message: DEFAULT_MESSAGE }),
  })
  .superRefine((values, context) => {
    if (values.is_export === '1' && !values.general_harbor_id) {
      context.addIssue({
        code: z.ZodIssueCode.custom,
        message: DEFAULT_MESSAGE,
        path: ['general_harbor_id'],
      });
    }
  });

export type FormSchema = z.infer<typeof formSchema>;

